import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

import { EnvironmentService } from '@offconon/shared/utils/services/environment';
import { SiteLanguageService } from '@offconon/shared/utils/services/site-language';
import { BrowserFingerprintService } from '@offconon/shared/utils/services/browser-fingerprint';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const siteLanguageService = inject(SiteLanguageService);
  const environmentService = inject(EnvironmentService);
  const browserFingerprintService = inject(BrowserFingerprintService);

  let finalUrl = request.url;
  if (request.url.includes('translation_group_json')) {
    return next(request);
  }

  try {
    const coreApiBase: string = environmentService.environment.coreApi || environment.coreApi;

    if (!coreApiBase) {
      console.error('AuthInterceptor: coreApiBase is missing!');
    }

    if (
      coreApiBase &&
      request.url.startsWith('http') &&
      !request.url.includes('translation_group_json')
    ) {
      const originalUrl = new URL(request.url);
      const coreApiUrl = new URL(coreApiBase);

      if (originalUrl.origin !== coreApiUrl.origin && originalUrl.pathname.startsWith('/api/')) {
        finalUrl = `${coreApiUrl.origin}${originalUrl.pathname}${originalUrl.search}`;
      }
    }
  } catch {}
  const isApiUrl =
    (environmentService.environment.coreApi &&
      finalUrl.startsWith(environmentService.environment.coreApi)) ||
    (environment.coreApi && finalUrl.startsWith(environment.coreApi));

  let authHeader = {};
  let fingerprintHeader = {};

  if (isApiUrl) {
    try {
      const raw = typeof localStorage !== 'undefined' ? localStorage.getItem('domainUser') : null;
      if (raw) {
        const parsed = JSON.parse(raw);
        const jwtToken = parsed?.loginResponse?.jwt_token;
        if (jwtToken) {
          try {
            const decoded: any = jwt_decode(jwtToken);
            const isExpired = decoded?.exp ? decoded.exp * 1000 < Date.now() : false;

            if (!isExpired) {
              authHeader = {
                Authorization: `Bearer ${jwtToken}`,
              };
            }
          } catch {
            // If decoding fails, don't send the token
          }
        }
      }
    } catch {}

    try {
      const fingerprint = browserFingerprintService.getFingerprint();
      if (fingerprint) {
        fingerprintHeader = {
          'X-Client-Fingerprint': fingerprint,
        };
      }
    } catch {}
  }

  request = request.clone({
    url: finalUrl,
    setHeaders: {
      ...authHeader,
      ...fingerprintHeader,
      LanguageId: siteLanguageService.actualSiteLanguageId().toString(),
    },
  });

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      return throwError(() => error);
    }),
  );
};
